import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, Select, Row, Col, message } from 'antd';

const CustomerCreateModal = ({ visible, onCancel, onSuccess, fetchData }) => {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);
  const [loadingOptions, setLoadingOptions] = useState(false);
  const [tags, setTags] = useState([]);
  const [staff, setStaff] = useState([]);

  useEffect(() => {
    if (!visible) {
      form.resetFields();
      return;
    }

    let mounted = true;
    setLoadingOptions(true);
    Promise.all([
      fetchData({ url: 'api/v1/company/tag/list?limit=0', method: 'GET' }),
      fetchData({ url: 'api/v1/staff/list?limit=100', method: 'GET' })
    ]).then(([tagResponse, staffResponse]) => {
      if (!mounted) return;
      setTags(Array.isArray(tagResponse.data) ? tagResponse.data : []);
      setStaff(Array.isArray(staffResponse.data) ? staffResponse.data : []);
    }).catch(() => {
      if (mounted) message.warning('Không tải được danh sách tag hoặc nhân viên');
    }).finally(() => {
      if (mounted) setLoadingOptions(false);
    });

    return () => { mounted = false; };
  }, [visible, fetchData, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setSubmitting(true);
      await fetchData({
        url: 'api/v1/customer',
        method: 'POST',
        data: values
      });
      message.success('Đã thêm khách hàng mới');
      form.resetFields();
      onSuccess();
    } catch (error) {
      if (!error || !error.errorFields) {
        message.error(error && error.message ? error.message : 'Không thể thêm khách hàng');
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      title="Thêm khách hàng"
      visible={visible}
      onCancel={onCancel}
      onOk={handleSubmit}
      okText="Thêm khách hàng"
      cancelText="Hủy"
      confirmLoading={submitting}
      width={720}
      destroyOnClose
      maskClosable={!submitting}
    >
      <Form form={form} layout="vertical" initialValues={{ source: 'Thêm thủ công', tags: [] }}>
        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Form.Item
              name="full_name"
              label="Họ tên"
              rules={[{ required: true, message: 'Vui lòng nhập họ tên' }]}
            >
              <Input placeholder="Nguyễn Văn A" maxLength={120} />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              name="phone"
              label="Số điện thoại"
              rules={[{ required: true, message: 'Vui lòng nhập số điện thoại' }]}
            >
              <Input placeholder="0901 234 567" maxLength={24} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Form.Item name="email" label="Email" rules={[{ type: 'email', message: 'Email không hợp lệ' }]}>
              <Input placeholder="khachhang@example.com" maxLength={160} />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item name="source" label="Nguồn khách hàng">
              <Input placeholder="Website, Hotline, Sự kiện..." maxLength={100} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Form.Item name="tags" label="Tags">
              <Select
                mode="multiple"
                allowClear
                loading={loadingOptions}
                placeholder="Chọn tag"
                optionFilterProp="children"
              >
                {tags.map((tag) => (
                  <Select.Option key={tag.tag_id} value={tag.tag_id}>{tag.tag_name}</Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item name="assigned_sale" label="Sale phụ trách">
              <Select
                allowClear
                showSearch
                loading={loadingOptions}
                placeholder="Chọn nhân viên"
                optionFilterProp="children"
              >
                {staff.map((item) => (
                  <Select.Option key={item._id} value={item._id}>{item.fullname || item.username}</Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Form.Item name="address" label="Địa chỉ">
          <Input placeholder="Địa chỉ khách hàng" maxLength={255} />
        </Form.Item>
        <Form.Item name="note" label="Ghi chú">
          <Input.TextArea rows={3} placeholder="Thông tin cần lưu ý về khách hàng" maxLength={1000} showCount />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CustomerCreateModal;
